import { NETWORK_FEED_TYPE } from '../constants/FeedType';
import LiveFeedApp from '../containers/LiveFeedApp';
import { LiveFeedProvider } from '../contexts/LiveFeedContext';
import { ModalProvider } from '../contexts/ModalContext';
import { TopPostsProvider } from '../contexts/TopPostsContext';

const LiveFeedAppClient = ({ config, amplitudeConfig }) => {
  const { type: configType } = config;
  const showTopPosts = configType === NETWORK_FEED_TYPE;

  return (
    <LiveFeedProvider config={config} amplitudeConfig={amplitudeConfig}>
      <ModalProvider>
        <TopPostsProvider isCallEnable={showTopPosts}>
          <LiveFeedApp />
        </TopPostsProvider>
      </ModalProvider>
    </LiveFeedProvider>
  );
};

export default LiveFeedAppClient;
